import { PropsWithChildren } from 'react';

import { Box, Theme, Typography, useMediaQuery } from '@material-ui/core';

import { TopRightSwirlArrowIcon } from '../Icons';

type SectionEmptyStateProps = PropsWithChildren<{
  title?: string;
  description?: string;
  hideArrow?: boolean;
}>;

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export const SectionEmptyStateMui = ({
  title,
  description,
  children,
  hideArrow = false,
}: SectionEmptyStateProps) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );

  return (
    <Box position="relative" textAlign="center" padding={isMobile ? 2 : 6}>
      {!hideArrow && (
        <Box
          display="block"
          textAlign="right"
          width="100%"
          position={isMobile ? 'relative' : 'absolute'}
          right={60}
          top={0}
        >
          <TopRightSwirlArrowIcon size={128} />
        </Box>
      )}
      <Box maxWidth={600} margin="0 auto">
        {title && (
          <Typography variant="h6" color="textPrimary">
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body1" color="textPrimary">
            {description}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  );
};
